export const initialState = {};

const updateTasksGroup = (updatedTasks) => {
  return (tg) => {
    return (
      updatedTasks.find((t) => {
        return !tg?.conditions && t.id === tg.id;
      }) || tg
    );
  };
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CLIENT_WORKFLOWS": {
      return action.clientWorkflows;
    }
    case "SET_CLIENT_WORKFLOW": {
      const nextState = { ...state };

      const hasTasksGroup = Boolean(
        state[action.clientWorkflow.id]?.tasksGroup
      );

      nextState[action.clientWorkflow.id] = {
        ...action.clientWorkflow,
        tasksGroup: hasTasksGroup
          ? state[action.clientWorkflow.id]?.tasksGroup.map(
              updateTasksGroup(action.clientWorkflow.tasks)
            )
          : action.clientWorkflow.tasks,
      };

      return nextState;
    }
    case "SET_CLIENT_WORKFLOW_TASKS": {
      const nextState = { ...state };
      const cwId = action.clientWorkflowId;

      nextState[cwId] = {
        ...nextState[cwId],
        numComments: action.numWorkflowComments,
        tasks: action.tasks,
        tasksGroup: action.tasksGroup,
      };

      return nextState;
    }
    case "SET_CLIENT_WORKFLOW_NEXT_WORKFLOWS": {
      const nextState = { ...state };

      action.clientWorkflows.forEach((cw) => {
        nextState[cw.id] = {
          ...nextState[cw.id],
          ...cw,
          tasks: cw.tasks.map((t) => {
            return {
              ...nextState[cw.id]?.tasks.find((st) => {
                return st.id === t.id;
              }),
              ...t,
            };
          }),
        };
      });

      return nextState;
    }
    case "DELETE_CLIENT_WORKFLOW": {
      const nextState = { ...state };
      delete nextState[action.clientWorkflowId];
      return nextState;
    }
    case "ADD_CLIENT_TASK":
      try {
        const nextState = { ...state };
        const wf = { ...nextState[action.task.clientWorkflowId] };
        nextState[action.task.clientWorkflowId] = {
          ...wf,
          tasks: [...wf.tasks, action.task],
          tasksGroup: state[action.task.clientWorkflowId]?.tasksGroup
            ? [...state[action.task.clientWorkflowId].tasksGroup, action.task]
            : state[action.task.clientWorkflowId]?.tasksGroup,
        };
        return nextState;
      } catch (error) {
        console.error(error);
        return state;
      }
    case "EDIT_CLIENT_TASK":
      try {
        const nextState = { ...state };
        const originalWF = nextState[action.task.clientWorkflowId];
        // Deep clone causes weird problems
        const wf = JSON.parse(JSON.stringify(originalWF));
        const index = wf.tasks.findIndex((t) => {
          return t.id === action.task.id;
        });
        wf.tasks[index] = action.task;

        const taskGroupIndex = wf.tasksGroup.findIndex((tg) => {
          return tg.id === action.task.id;
        });

        wf.tasksGroup[taskGroupIndex] = action.task;

        nextState[action.task.clientWorkflowId] = wf;
        return nextState;
      } catch (error) {
        console.error(error);
        return state;
      }
    case "DELETE_CLIENT_TASK":
      try {
        const wf = { ...state[action.clientWorkflowId] };
        wf.tasks = [
          ...wf.tasks.filter((t) => {
            return t.id !== action.taskId;
          }),
        ];
        wf.tasksGroup = wf.tasksGroup.filter((tg) => {
          return tg.id !== action.taskId;
        });

        const nextState = { ...state };
        nextState[action.clientWorkflowId] = wf;
        return nextState;
      } catch (error) {
        console.error(error);
        return state;
      }
    case "BULK_UPDATE_CLIENT_TASKS":
      try {
        const nextState = { ...state };
        nextState[action.tasks[0].clientWorkflowId].tasks = action.tasks;
        return nextState;
      } catch (e) {
        console.error(e);
        return state;
      }
    case "BULK_UPDATE_CLIENT_WORKFLOWS":
      try {
        const nextState = { ...state };
        action.clientWorkflows.forEach((cw) => {
          const cwTasks = cw.tasks.map((t) => {
            return t.id;
          });

          nextState[cw.id] = {
            ...cw,
            tasksGroup: (cw?.tasksGroup || state[cw.id].tasksGroup)
              .filter((tg) => {
                return (
                  tg?.conditions || (!tg?.conditions && cwTasks.includes(tg.id))
                );
              })
              .map(updateTasksGroup(cw.tasks)),
          };
        });

        return nextState;
      } catch (e) {
        console.error(e);
        return state;
      }
    case "TOGGLE_WORKFLOW_COMPLETION_ENABLED":
      try {
        const nextState = { ...state };
        nextState[action.clientWorkflowId] = {
          ...nextState[action.clientWorkflowId],
          workflowCompletionEnabled: action.buttonEnabled,
        };
        return nextState;
      } catch (e) {
        console.error(e);
        return state;
      }
    case "UPDATE_TASK_REMINDER":
      try {
        const nextState = { ...state };

        const updateReminder = (task) => {
          return task.id === action.reminder.taskId
            ? {
                ...task,
                reminders: task.reminders.map((r) => {
                  if (r.id === action.reminder.id) {
                    return action.reminder;
                  } else {
                    return r;
                  }
                }),
              }
            : task;
        };

        nextState[action.reminder.clientWorkflowId] = {
          ...nextState[action.reminder.clientWorkflowId],
          tasks:
            nextState[action.reminder.clientWorkflowId].tasks.map(
              updateReminder
            ),
          tasksGroup:
            nextState[action.reminder.clientWorkflowId].tasksGroup.map(
              updateReminder
            ),
        };
        return nextState;
      } catch (e) {
        console.error(e);
        return state;
      }
    default:
      return state;
  }
};

export const clientWorkflowLoader = (
  state = { loading: false, error: null },
  action
) => {
  switch (action.type) {
    case "FETCHING_CLIENT_WITH_WORKFLOWS": {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
